$(document).on('focus', '[data-item-configuration-form] input', function() {
  $(this).select();
});

$(document)
  .off('change', '[data-item-configuration-form] [data-item-configuration-evaluate]')
  .on('change', '[data-item-configuration-form] [data-item-configuration-evaluate]', function() {
    const $form = $(this).closest('[data-item-configuration-form]');
    const hiddens = $form.find('input[type="hidden"]').map(function() {
      return this.name;
    }).get();
    hiddens.push('step');

    const data = $form.serializeArray();
    let evaluate = true;
    data.filter(item => !hiddens.includes(item.name)).forEach((item) => {
      if (!evaluate || !item.value || ['0', '0.000'].includes(item.value)) {
        evaluate = false;
      }
    });
    if (evaluate) {
      $form.submit();
    }
  });
